import { PlusIcon } from '@heroicons/react/16/solid';
import { useMemo, useState } from 'react';
import { useFieldArray, useWatch } from 'react-hook-form';
import { FadeInOut } from './fade-in-out';
import { Button } from './ui/button';
import { TrashCard } from './ui/trash-card';

export function ManualSection({
  fieldArrayName,
  ItemComponent,
  showFromButtonLabel,
  FormComponent,
}) {
  const [showForm, setShowForm] = useState(false);
  const { remove } = useFieldArray({ name: fieldArrayName });
  const items = useWatch({ name: fieldArrayName });
  const itemsList = useMemo(
    () =>
      items.map((item, index) => (
        <FadeInOut key={JSON.stringify(item)}>
          <TrashCard
            className="min-h-17.5"
            onClick={(e) => {
              e.preventDefault();
              remove(index);
            }}
          >
            <ItemComponent item={item} />
          </TrashCard>
        </FadeInOut>
      )),
    [items, remove],
  );
  const show = showForm || items.length === 0;
  return (
    <>
      <div className="relative mb-2.5 z-1 py-5 space-y-2.5 empty:hidden before:absolute before:-z-1 before:top-0 before:left-[-99999px] before:right-[-99999px] before:bottom-0 before:bg-gray-100">
        {itemsList}
      </div>
      <FadeInOut show={!show}>
        <Button
          type="button"
          variant="outlined"
          className="min-h-12.5 flex items-center justify-center gap-3"
          onClick={(e) => {
            e.preventDefault();
            setShowForm(true);
          }}
        >
          <PlusIcon className="size-5 text-gray-500" />
          {showFromButtonLabel}
        </Button>
      </FadeInOut>
      <FadeInOut show={show} unmount={true}>
        <FormComponent onAdd={() => setShowForm(false)} />
      </FadeInOut>
    </>
  );
}
